module.exports = {
    "Clear search": `Borrar b\xfasqueda`
};


//# sourceMappingURL=es-ES.main.js.map
